import { KText } from '@/ui-library/components';
import { Flex, Switch, Tooltip } from '@chakra-ui/react';
import { getAtsJobCreate } from '@/store/atsJobCreate';
import { useState } from 'react';
import { useSelector } from 'react-redux';

export const PublicprivateSchedulingField = ({
  updateSharedData,
  interviewPlan,
}) => {
  const { currentJob = {} } = useSelector(getAtsJobCreate);
  const [isPrivateInterview, setIsPrivateInterview] = useState(
    interviewPlan?.calendar_visibility === 'private' ? true : false
  );
  const privateCalendarVisibility =
    interviewPlan?.calendar_visibility === 'private' &&
    currentJob?.data?.confidential === true;
  const togglePrivateInterview = () => {
    if (privateCalendarVisibility) {
      return;
    }
    const newValue = !isPrivateInterview;
    const calendarVisibility = newValue ? 'private' : 'default';
    updateSharedData('calendar_visibility', calendarVisibility);
    setIsPrivateInterview(newValue);
  };

  return (
    <Tooltip
      label={
        privateCalendarVisibility
          ? 'Interviews for confidential jobs are always private'
          : ''
      }
      placement="left"
      hasArrow
    >
      <Flex flexDir="column" gap="12px" mt="12px" mb="4px">
        <Flex
          alignItems="center"
          justifyContent="space-between"
          cursor={privateCalendarVisibility ? 'not-allowed' : 'pointer'}
          onClick={togglePrivateInterview}
        >
          <Flex flexDir="column" gap="6px">
            <KText size="sm-medium" color="secondary-900">
              Make the interview private
            </KText>
            <KText size="sm-medium">
              Hide calendar event details from non-attendees
            </KText>
          </Flex>

          <Switch
            isChecked={isPrivateInterview}
            onChange={() => {
              setIsPrivateInterview((prev) => {
                const newValue = !prev;
                updateSharedData(
                  'calendar_visibility',
                  newValue ? 'private' : 'default'
                );
                return newValue;
              });
            }}
            disabled={privateCalendarVisibility}
            className={`ats-switch-toogle ${
              isPrivateInterview ? 'active' : 'unactive'
            }`}
            colorScheme="primary-500"
          />
        </Flex>
      </Flex>
    </Tooltip>
  );
};
